const DEVICE_VIEW_LABELS = new Map<number, string>([
  [5, '五目'],
  [11, '五目'],
  [9, '双目'],
  [10, '双目'],
  [12, '四目'],
  [13, '四目'],
  [14, '四目'],
]);

const DOWNWARD_CAMERA_POSITIONS = new Set([
  'down',
  'downward',
  'facing_down',
  'camera_down',
  'hand_down',
  'hand_camera_down',
  '朝下',
  '手部镜头朝下',
  '镜头朝下',
  '鏈濅笅',
]);

export function getDeviceViewLabel(deviceTypeEnum: number | null): string | null {
  if (deviceTypeEnum == null) return null;
  return DEVICE_VIEW_LABELS.get(deviceTypeEnum) ?? '未知设备';
}

export function isDownwardCameraPosition(cameraPosition: string | null): boolean {
  if (!cameraPosition) return false;
  const normalized = cameraPosition
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
  return DOWNWARD_CAMERA_POSITIONS.has(normalized);
}
